import Visits from './Visits';

export default Visits;
